import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import "./logo.css"

const Logo = ({
  title = "",
  href = "#",
  isDarkMode = false,
  className = "",
}) => (
  <Link to={href} className={`mr-12 logo ${className}`}>
    <StaticImage
      src="../../images/savorbrands_logo.png"
      formats={["auto", "webp", "avif"]}
      alt={title || 'Savor Brands Logo'}
      className={isDarkMode ? "filter-blackout" : ""}
    />
  </Link>
)

export default Logo
